import DisclosureGuidelineModal from '@Components/Bases/DisclosureGuidelineModal';
import Flex from '@Components/Bases/Flex';
import InfoPopUpIcon from '@Components/Icons/InfoPopUpIcon';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box, Button, Typography } from '@mui/material';

const DisclosureGuidelineClimateChangeStructure = () => {
  const [opened, { open, close }] = useDisclosure();
  return (
    <Box>
      <Button color="inherit" startIcon={<InfoPopUpIcon />} onClick={open}>
        แนวทางการเปิดเผย
      </Button>
      <DisclosureGuidelineModal
        open={opened}
        onClose={close}
        title="โครงสร้างการกำกับดูแลกิจการ"
        description={
          <>
            <Typography sx={{ textIndent: 90 }}>
              ให้แสดงแผนภาพการบริหารจัดการองค์กรตั้งแต่คณะกรรมการ
              คณะกรรมการชุดย่อย ฝ่ายจัดการ ไปจนถึงฝ่ายงานต่าง ๆ
              รวมถึงหน่วยงานที่เป็นกลไกในการกำกับดูแลกิจการ เช่น
              หน่วยงานตรวจสอบภายใน หน่วยงานกำกับดูแลองค์กร
              หน่วยงานบริหารความเสี่ยง
              เพื่อสะท้อนให้เห็นถึงลำดับขั้นสายการบังคับบัญชา การสนับสนุน
              การตรวจสอบ ความเป็นอิสระ
              และการแบ่งแยกหน้าที่ระหว่างคณะกรรมการและฝ่ายจัดการ
            </Typography>
            <Typography sx={{ textIndent: 90 }} mt={4}>
              ตัวอย่างการเปิดเผยแผนภาพโครงสร้างการกำกับดูแลกิจการ ณ วันที่
              ....(ณ วันสิ้นงวดปีบัญชี).....(หากภายหลังวันสิ้นงวดปีบัญชี
              บริษัทมีการปรับเปลี่ยนโครงสร้างการบริหารจัดการอย่างมีนัยสำคัญ
              ก็ควรจะเปิดเผยข้อมูลดังกล่าวเพิ่มเติมด้วย)
            </Typography>
            <Box
              component="img"
              width={1}
              alt="Climate Change Structure"
              src="/assets/disclosure/ClimateChangeStructure.png"
              mt={2}
            />
            <Flex ml={11} mt={4}>
              <Typography color="red">*</Typography>
              <Typography>
                บริษัทสามารถจัดตั้งคณะกรรมการบริหารความเสี่ยงในระดับคณะกรรมการชุดย่อยหรือระดับจัดการก็ได้
              </Typography>
            </Flex>
            <Typography
              fontWeight="bold"
              sx={{
                textDecoration: 'underline',
                textIndent: 90,
              }}
              mt={2}
            >
              คำแนะนำหรือคำอธิบายเพิ่มเติม
            </Typography>
            <Typography sx={{ textIndent: 90 }} mt={1}>
              ให้บริษัทเปิดเผยชื่อและตำแหน่งของผู้บริหารซึ่งต้องสอดคล้องกับข้อมูลตามโครงสร้างการบริหารจัดการของบริษัท
              (organization chart) โดยให้ระบุให้ชัดเจนว่า
              บุคคลใดคือผู้ที่ดำรงตำแหน่งผู้บริหารสูงสุด ทั้งนี้
              หากบริษัทต้องการเปิดเผยรายชื่อผู้บริหารเกินกว่านิยามตามประกาศคณะกรรมการ
              ก.ล.ต. กำหนด บริษัทควรระบุข้อมูลให้ทราบว่า
              ผู้บริหารรายใดไม่ได้เป็นผู้บริหารตามนิยาม
              ดังกล่าวด้วยและหากบริษัทมีการเปลี่ยนแปลงกรรมการหรือผู้บริหารหลังวันสิ้นงวดบัญชีประจำปี
              แต่ก่อนส่งแบบ Corporate Value Up
              บริษัทควรเปิดเผยข้อมูลการเปลี่ยนแปลงกรรมการหรือผู้บริหารดังกล่าวเพิ่มเติมในแบบ
            </Typography>
          </>
        }
      />
    </Box>
  );
};

export default DisclosureGuidelineClimateChangeStructure;
